export default __webpack_public_path__ + "static/media/banner-03.d2283173.jpg";